import React, { useState } from 'react';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { HeaderText } from 'components/atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import useStyle from './featureMySkills.style';
import {
  GraphRadar,
  GraphRadarValue
} from 'components/molecules/Charts/GraphRadar';
import { IconButton } from 'components/atoms/Buttons/IconButton';
import { MySkillsLegend } from 'components/atoms/MySkills/MySkillsLegend';

export interface FeatureMySkillsViewProps {
  radarData: GraphRadarValue[];
}

export const FeatureMySkillsView = ({
  radarData
}: FeatureMySkillsViewProps) => {
  const [showLegend, setShowLegend] = useState(false);
  const classes = useStyle({ showLegend });
  return (
    <div className={classes.root}>
      <HeaderText text="Mes compétences" emoji={emojis['LightBulb']} />

      <FeatureContainer
        buttonPosition={!showLegend ? 'bottomRight' : 'topRight'}
        padding="dashboardChart"
        iconButton={
          <IconButton
            onClick={() => setShowLegend(!showLegend)}
            variant="backless"
            icon={!showLegend ? 'Info' : 'Close'}
          />
        }
      >
        {!showLegend ? (
          <GraphRadar values={radarData} />
        ) : (
          <MySkillsLegend chartData={radarData} />
        )}
      </FeatureContainer>
    </div>
  );
};
